import {
    ArrowDownTrayIcon,
    PencilSquareIcon,
    TrashIcon,
    UserCircleIcon
} from '@heroicons/react/24/outline';
import type { PreviewAction } from './previewActionMenuModel';
import type { ImagePreviewActionId } from './previewActionRules';

type ImagePreviewActionDefinition = Omit<PreviewAction, 'onSelect' | 'pending'>;

const IMAGE_PREVIEW_ACTION_DEFINITIONS: Record<ImagePreviewActionId, ImagePreviewActionDefinition> =
    {
        'set-profile-picture': {
            id: 'set-profile-picture',
            label: 'Set as profile picture',
            pendingLabel: 'Setting profile picture...',
            icon: UserCircleIcon,
            group: 'profile'
        },
        edit: {
            id: 'edit',
            label: 'Edit',
            icon: PencilSquareIcon,
            group: 'file'
        },
        download: {
            id: 'download',
            label: 'Download',
            pendingLabel: 'Downloading...',
            icon: ArrowDownTrayIcon,
            group: 'file'
        },
        delete: {
            id: 'delete',
            label: 'Delete',
            pendingLabel: 'Deleting...',
            icon: TrashIcon,
            group: 'destructive',
            tone: 'danger'
        }
    };

export interface ImagePreviewActionContext {
    onSelect: Record<ImagePreviewActionId, () => void>;
    pending: Partial<Record<ImagePreviewActionId, boolean>>;
}

export const buildImagePreviewAction = (
    id: ImagePreviewActionId,
    { onSelect, pending }: ImagePreviewActionContext
): PreviewAction => ({
    ...IMAGE_PREVIEW_ACTION_DEFINITIONS[id],
    pending: pending[id],
    onSelect: onSelect[id]
});

export const buildImagePreviewActions = (
    ids: readonly ImagePreviewActionId[],
    context: ImagePreviewActionContext
): PreviewAction[] => ids.map((id) => buildImagePreviewAction(id, context));
